// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6b38bccc","703":"3953e994","787":"0817133b"}[chunkId] + ".chunk.js";
};